const Generator = () => {
  return new Promise((resolve) => {
    function cpf () {
      const n1 = Math.round(Math.random() * 9)
      const n2 = Math.round(Math.random() * 9)
      const n3 = Math.round(Math.random() * 9)
      const n4 = Math.round(Math.random() * 9)
      const n5 = Math.round(Math.random() * 9)
      const n6 = Math.round(Math.random() * 9)
      const n7 = Math.round(Math.random() * 9)
      const n8 = Math.round(Math.random() * 9)
      const n9 = Math.round(Math.random() * 9)

      let d1 = n9 * 2 + n8 * 3 + n7 * 4 + n6 * 5 + n5 * 6 + n4 * 7 + n3 * 8 + n2 * 9 + n1 * 10
      d1 = 11 - (Math.round(d1 - (Math.floor(d1 / 11) * 11)))
      if (d1 >= 10) d1 = 0

      let d2 = d1 * 2 + n9 * 3 + n8 * 4 + n7 * 5 + n6 * 6 + n5 * 7 + n4 * 8 + n3 * 9 + n2 * 10 + n1 * 11
      d2 = 11 - (Math.round(d2 - (Math.floor(d2 / 11) * 11)))
      if (d2 >= 10) d2 = 0

      return "" + n1 + n2 + n3 + n4 + n5 + n6 + n7 + n8 + n9 + d1 + d2
    }

    function creditcard () {
      const prefix = {
        visa: [
          "4539",
          "4556",
          "4916",
          "4532",
          "4929",
          "40240071",
          "4485",
          "4716",
          "4",
        ],

        master: [
          "51",
          "52",
          "53",
          "54",
          "55",
        ],
      }

      function strrev (str) {
        if (!str) return ""
        var revstr = ""
        var i
        for (i = str.length - 1; i >= 0; i--) { revstr += str.charAt(i) }
        return revstr
      }

      function completednumber (prefix, length) {
          var ccnumber = prefix

          while (ccnumber.length < (length - 1)) {
              ccnumber += Math.floor(Math.random() * 10)
          }

          var reversedCCnumberString = strrev(ccnumber)

          var reversedCCnumber = []
          for (var i = 0; i < reversedCCnumberString.length; i++) {
              reversedCCnumber[i] = parseInt(reversedCCnumberString.charAt(i))
          }

          var sum = 0
          var pos = 0
          var odd

          while (pos < length - 1) {
              odd = reversedCCnumber[pos] * 2
              if (odd > 9) {
                  odd -= 9
              }

              sum += odd

              if (pos !== (length - 2)) {
                  sum += reversedCCnumber[pos + 1]
              }
              pos += 2
          }

          var checkdigit = ((Math.floor(sum / 10) + 1) * 10 - sum) % 10
          ccnumber += checkdigit

          return ccnumber
      }

      function creditcardnumber (prefixList, length, howMany) {
          for (var i = 0; i < howMany; i++) {
              var randomArrayIndex = Math.floor(Math.random() * prefixList.length)
          }
          return completednumber(prefixList[randomArrayIndex], length)
      }

      return creditcardnumber(prefix[Object.keys(prefix)[Math.floor((Math.random() * 2))]], 16, 1)
    }

    resolve({
      cpf: cpf(),
      creditcard: creditcard(),
    })
  })
}

export {
  Generator,
}
